import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Modules } from 'app/core/application/features/modules';
import { LoginService } from 'app/services/login.service';
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    constructor(
        public  _modules: Modules,
        
        private _router: Router,
        private _loginService:LoginService
    ) { }

    async ngOnInit() {}

    onMenuClick(event) {
        switch (event.currentTarget.id) {
            case 'miLogout': {
                this.onLogout();
                break;
            }
            case 'miPortal': {
                break;
            }
            case 'miParametro': {
                this._router.navigate(['parametros']);
            }
            case 'miSobre': {
                break;
            }
            case 'miPainelControle': {
            }
            case 'miUsuario': {
                this._router.navigate(['usuarios']);
                break;
            }
        }

    }
    
    onLogout() {
        this._loginService.logout('TIVIC');
        this._router.navigate(['/login']);
    }
}